import * as React from "react";

import VitalsSummaryHelpers from "./VitalsSummaryHelpers";
import DatasetAuthorizationWrapper from "src/common/DatasetAuthorizationWrapper";

import { Input, Select, Form, InputNumber } from "antd";
import DropdownInputAnt from "src/components/forms/DropdownInputAnt";
import { Page, PageHero, Spinner } from "src/components/common";

import LocationAPI from "src/admin/Organization/Location/LocationAPI";
import VitalsAPI from "./VitalsAPI";
import AssessmentResultsAPI from "src/admin/results/AssessmentResultsAPI";
import { ClientPermissions } from "src/common/Permissions";

import { Validation } from "src/common/utils";
import { Button } from "src/components/buttons";

import { AdminPermissions } from "src/common/Permissions";
import PickListContext from "src/context/pickListContext";

// tslint:disable-next-line:max-line-length
import {
	ICustomFieldValidation,
	CustomFieldContainer,
	getCustomFieldValues,
	getCustomFieldValidation,
} from "src/admin/Organization/CustomFields/CustomFieldContainer";
import { toast } from "react-toastify";

interface IProps {
	location?: any;
	match?: any;
	history?: any;
	currentUser?: any;
}

interface IState {
	customFields: CustomFieldDTO[];
	customFieldValues: CustomFieldValueDTO[];
	locations: LocationDTO[];
	vitalsTestResult: VitalsTestResultDTO;
	isPageLoading: boolean;
	vitalsCustomFieldValidation: string[];
	currentUser: CurrentUserDTO;
	completedTasks: VitalsCompletedTasksDTO[];
	dataLocked: boolean;
}

class VitalSummary extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	constructor(props: any) {
		super(props);
		this.state = {
			customFields: [],
			customFieldValues: [],
			locations: [],
			vitalsTestResult: {},
			isPageLoading: true,
			vitalsCustomFieldValidation: [],
			currentUser: {},
			completedTasks: [],
			dataLocked: true,
		};
	}

	public componentDidMount() {
		const {
			organizationId,
			datasetId,
			clientId,
			vitalsTestResultId,
			sessionId,
		} = this.props.match.params;

		const p_clientSiteDatasetLocations =
			LocationAPI.getClientSiteDatasetLocations({
				organizationId,
				datasetId,
			});

		const p_vitalsTestResult = VitalsAPI.getVitalsTestResult({
			clientId,
			vitalsTestResultId,
		});

		const p_completedTasks = VitalsAPI.getCompletedTasks({
			datasetId,
			vitalsTestResultId: vitalsTestResultId,
		});

		const p_session = AssessmentResultsAPI.getSession({
			datasetId,
			clientId,
			sessionId,
		});

		Promise.all([
			p_clientSiteDatasetLocations,
			p_vitalsTestResult,
			p_completedTasks,
			p_session,
		]).then((values) => {
			const [locations, vitalsTest, completedTasks, session] = values;

			if (locations.length == 1 && !vitalsTest.locationId) {
				vitalsTest.locationId = locations[0].id;
			}

			this.setState({
				locations,
				vitalsTestResult: vitalsTest,
				completedTasks,
				currentUser: this.props.currentUser,
				isPageLoading: false,
				dataLocked: session.dataLocked === false ? false : true,
			});
		});
	}

	public render() {
		const { vitalsTestResult, locations, isPageLoading, completedTasks } =
			this.state;
		const validVitalsTestResult = {
			locationId: Validation.validateIsGreaterThan(
				this.state.vitalsTestResult.locationId!,
				0,
				"Please select a valid dataset location"
			),
			customFieldValues:
				this.state.vitalsCustomFieldValidation.length > 0
					? this.state.vitalsCustomFieldValidation
					: [],
		};

		return isPageLoading ? (
			<Spinner />
		) : (
			<>
				<Page title="VITALS Summary">
					<PageHero>
						<h1 className="mb-0">VITALS Summary</h1>
					</PageHero>
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-6 col-lg-4 form-group">
								<label>Test length</label>
								<Form.Item>
									<InputNumber
										name="testHour"
										min={0}
										max={23}
										value={vitalsTestResult.testHour}
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "testHour")
										}
										type="number"
									/>
									<span className="m-2">Hour</span>
									<InputNumber
										name="testMinute"
										min={0}
										max={59}
										value={vitalsTestResult.testMinute}
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "testMinute")
										}
										type="number"
									/>
									<span className="m-2">Minutes</span>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Location *</label>
								<Form.Item
									validateStatus={
										validVitalsTestResult.locationId.validationStatus
									}
									help={validVitalsTestResult.locationId.message}
									required={true}
									hasFeedback={true}
								>
									<Select
										id="locationId"
										placeholder=""
										value={locations
											.filter((loc) => loc.id === vitalsTestResult.locationId!)
											.map((loc) => ({ key: loc.id!, label: loc.name! }))}
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "locationId")
										}
										labelInValue={true}
									>
										{locations
											.filter((l) => l.isActive === true)
											.map((location) => {
												return (
													<Select.Option
														key={location.id!.toString()}
														value={location.id}
													>
														{location.name}
													</Select.Option>
												);
											})}
									</Select>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Cooperative</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="cooperativeId"
										placeholder=""
										required={true}
										value={vitalsTestResult.cooperativeId!}
										pickListCode="Cooperative"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "cooperativeId")
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
						</div>
						<div className="row">
							<div className="col-12 form-group">
								<span>
									Other assessment factors: Please only indicate problems that
									you feel had a direct impact on the validity of the
									assessment.
								</span>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Visual impairments</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="visualImpairmentId"
										placeholder=""
										required={true}
										value={vitalsTestResult.visualImpairmentId}
										pickListCode="VisualImpairment"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "visualImpairmentId")
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Hearing impairments</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="hearingImpairmentId"
										placeholder=""
										required={true}
										value={vitalsTestResult.hearingImpairmentId}
										pickListCode="HearingImpairment"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(
												value,
												"hearingImpairmentId"
											)
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Physical impairments</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="physicalImpairmentId"
										placeholder=""
										required={true}
										value={vitalsTestResult.physicalImpairmentId}
										pickListCode="PhysicalImpairment"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(
												value,
												"physicalImpairmentId"
											)
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Language comprehension</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="languageComprehensionId"
										placeholder=""
										required={true}
										value={vitalsTestResult.languageComprehensionId}
										pickListCode="LanguageComprehension"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(
												value,
												"languageComprehensionId"
											)
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
							<div className="col-md-6 col-lg-4 form-group">
								<label>Anxiety level</label>
								<Form.Item required={true}>
									<DropdownInputAnt
										name="anxietyLevelId"
										placeholder=""
										required={true}
										value={vitalsTestResult.anxietyLevelId}
										pickListCode="AnxietyLevel"
										onChange={(value: any) =>
											this.onVitalsTestResultChange(value, "anxietyLevelId")
										}
										sort={true}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
						</div>
						<div className="row">
							<div className="col-md-8 col-lg-6 form-group">
								<CustomFieldContainer
									organizationId={+this.props.match.params.organizationId}
									datasetId={+this.props.match.params.datasetId}
									customFieldTypes={["VitalsType"]}
									customFieldTypeIds={{
										typeOfCustomFieldValue: "VitalsType",
										value: this.props.match.params.vitalsTestResultId,
									}}
									pickListItems={this.context.pickListItems}
									getCustomFieldValidation={this.getVitalsCustomFieldValidation}
									getCustomFieldValueFromState={this.getVitalsCustomFieldValues}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-md-8 col-lg-6 form-group">
								<label htmlFor="comments">Comments</label>
								<Form.Item>
									<Input.TextArea
										id="comments"
										name="comments"
										value={vitalsTestResult.comments}
										onChange={this.onCommentChange}
										disabled={this.state.dataLocked}
									/>
								</Form.Item>
							</div>
						</div>
					</div>
					<DatasetAuthorizationWrapper
						type="hide"
						permissions={[ClientPermissions.EditVitalsTest]}
					>
						<div className="form-group">
							<div>
								<Button
									className="btn-outline-primary ml-3"
									onClick={this.onCancelClick}
								>
									Cancel
								</Button>
								<Button
									className="btn-primary ml-3"
									onClick={this.updateVitalsTestResult}
									disabled={
										!this.isValidVitalsTestResult(validVitalsTestResult)
									}
								>
									Save
								</Button>
								<Button
									className="btn-primary ml-3"
									onClick={this.scoreVitalsTestResult}
									disabled={
										this.state.dataLocked === true
											? true
											: !this.isValidVitalsTestToScore(
													validVitalsTestResult,
													completedTasks
											  )
									}
								>
									Save and Score
								</Button>
							</div>
						</div>
					</DatasetAuthorizationWrapper>
				</Page>
			</>
		);
	}

	// exported from customfield container
	private getVitalsCustomFieldValues = (
		customFieldValues: CustomFieldValueDTO[]
	) => {
		const vitalsCustomFieldValues = getCustomFieldValues(customFieldValues);
		const vitalsTestResult = this.state.vitalsTestResult;
		if (vitalsCustomFieldValues.length > 0) {
			vitalsTestResult.vitalsCustomFieldValues = vitalsCustomFieldValues;
			this.setState({ vitalsTestResult });
		}

		return;
	};

	private getVitalsCustomFieldValidation = (
		validation: ICustomFieldValidation[]
	) => {
		const validCustomFieldValues = getCustomFieldValidation(validation);
		const validCustomFieldValuesValidationStatus = validCustomFieldValues.map(
			(c) => {
				if (c.validationStatus === undefined) {
					// just need to know if its success or error this is an edge case
					return "";
				} else {
					return c.validationStatus;
				}
			}
		);
		this.setState({
			vitalsCustomFieldValidation: validCustomFieldValuesValidationStatus,
		});
	};

	private onVitalsTestResultChange = (value: any, name: string) => {
		let vitalsTest = {};
		if (typeof value === "object") {
			const dropdownChoice = value.key;
			vitalsTest = { ...this.state.vitalsTestResult, [name]: dropdownChoice };
		} else {
			vitalsTest = { ...this.state.vitalsTestResult, [name]: value };
		}
		this.setState({ vitalsTestResult: vitalsTest });
	};

	private onCommentChange = (event: any) => {
		const value = event.target.value;
		const vitalsTest = {
			...this.state.vitalsTestResult,
			comments: value,
		};
		this.setState({ vitalsTestResult: vitalsTest });
	};

	private onCancelClick = () => {
		const { organizationId, datasetId, clientId } = this.props.match.params;
		this.props.history.push(
			`/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/results`
		);
	};

	private isValidVitalsTestResult = (targetToBeValidated: any) => {
		var vitalsTestResult = this.state.vitalsTestResult;
		if (this.state.dataLocked) {
			return false;
		}
		return Validation.isValidIncludingCustomFields(
			targetToBeValidated,
			"vitalsCustomFieldValues"
		);
	};

	private isValidVitalsTestToScore = (
		targetToBeValidated: any,
		completedTasks: any
	) => {
		return (
			Validation.isValidIncludingCustomFields(
				targetToBeValidated,
				"vitalsCustomFieldValues"
			) &&
			VitalsSummaryHelpers.canScoreVitalsTest(completedTasks) &&
			this.state.vitalsTestResult.dateScored == null
		);
	};

	private scoreVitalsTestResult = () => {
		const { organizationId, datasetId, clientId, vitalsTestResultId } =
			this.props.match.params;

		this.saveVitalsTestResult().then(() => {
			VitalsAPI.scoreVitalsTest({
				vitalsTestResultId: vitalsTestResultId,
				datasetId: datasetId,
			})
				.then(() =>
					this.props.history.push(
						`/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/results`
					)
				)
				.catch((e) => toast.error("An error occurred scoring the VITALS test"));
		});
	};

	private updateVitalsTestResult = () => {
		const { organizationId, datasetId, clientId, vitalsTestResultId } =
			this.props.match.params;
		this.saveVitalsTestResult().then(() => {
			this.props.history.push(
				`/organizations/${organizationId}/datasets/${datasetId}/clients/${clientId}/results`
			);
		});
	};

	private saveVitalsTestResult = () => {
		const { datasetId, clientId, vitalsTestResultId } = this.props.match.params;
		const { vitalsTestResult, currentUser } = this.state;
		return new Promise<void>((resolve, reject) => {
			if (
				!currentUser.permissions!.includes(AdminPermissions.GlobalAdmin) &&
				!currentUser.vitalsCertified
			) {
				toast.error("Do not have authorization to update VITALS test result");
				reject();
			}
			const updateRequest = {
				id: +vitalsTestResultId,
				clientId,
				datasetId,
				dateAdministered: vitalsTestResult.dateAdministered,
				locationId: vitalsTestResult.locationId,
				cooperativeId: vitalsTestResult.cooperativeId,
				visualImpairmentId: vitalsTestResult.visualImpairmentId,
				hearingImpairmentId: vitalsTestResult.hearingImpairmentId,
				physicalImpairmentId: vitalsTestResult.physicalImpairmentId,
				languageComprehensionId: vitalsTestResult.languageComprehensionId,
				languageId: vitalsTestResult.languageId,
				anxietyLevelId: vitalsTestResult.anxietyLevelId,
				comments: vitalsTestResult.comments,
				testHour: vitalsTestResult.testHour,
				testMinute: vitalsTestResult.testMinute,
				vitalsCustomFieldValues:
					this.state.vitalsTestResult.vitalsCustomFieldValues!,
			} as UpsertVitalsTestResultRequest;
			VitalsAPI.upsertVitalsTest(updateRequest)
				.then(() => {
					toast.success("Updated VITALS test result");
					resolve();
				})
				.catch((res) => {
					toast.error("An error occurred saving VITALS summary");
					reject(res);
				});
		});
	};
}

export default VitalSummary;
